export default "__VITE_ASSET__DlssvcUU__"